module.exports = __webpack_public_path__ + "static/media/18ECA24.337f7a53.jpg";